import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ybcwbttitirdwbjtitsk.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_gsHORs-OWooYG4WzhAIcHw_5D81FM84';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
